export default {

    kanban: {
        edit: { type: "Kanban", value: "Edit" },
        show: { type: "Kanban", value: "Show" },
    },
    account: {
        edit: { type: "Account", value: "Edit" },
        delete: { type: "Account", value: "Delete" },
        show: { type: "Account", value: "Show" },
    },
    action: {
        edit: { type: "Action", value: "Edit" },
        delete: { type: "Action", value: "Delete" },
        show: { type: "Action", value: "Show" },
    },
    environment: {
        edit: { type: "Environment", value: "Edit" },
        delete: { type: "Environment", value: "Delete" },
        show: { type: "Environment", value: "Show" },
    },
    entityFieldCustom: {
        edit: { type: "EntityFieldCustom", value: "Edit" },
        delete: { type: "EntityFieldCustom", value: "Delete" },
        show: { type: "EntityFieldCustom", value: "Show" },
    },
    item: {
        edit: { type: "Item", value: "Edit" },
        delete: { type: "Item", value: "Delete" },
        show: { type: "Item", value: "Show" },
    },
    job: {
        edit: { type: "Job", value: "Edit" },
        delete: { type: "Job", value: "Delete" },
        show: { type: "Job", value: "Show" },
    },
    jobStage: {
        edit: { type: "JobStage", value: "Edit" },
        delete: { type: "JobStage", value: "Delete" },
        show: { type: "JobStage", value: "Show" },
    },
    reg: {
        edit: { type: "Reg", value: "Edit" },
        delete: { type: "Reg", value: "Delete" },
        show: { type: "Reg", value: "Show" },
    },
    regType: {
        edit: { type: "RegType", value: "Edit" },
        delete: { type: "RegType", value: "Delete" },
        show: { type: "RegType", value: "Show" },
    },
    resource: {
        edit: { type: "Resource", value: "Edit" },
        delete: { type: "Resource", value: "Delete" },
        show: { type: "Resource", value: "Show" },
    },
    report: {
        edit: { type: "Report", value: "Edit" },
        delete: { type: "Report", value: "Delete" },
        show: { type: "Report", value: "Show" },
    }, printer: {
        edit: { type: "Report", value: "Edit" },
        delete: { type: "Report", value: "Delete" },
        show: { type: "Report", value: "Show" },
    },
    stageType: {
        edit: { type: "StageType", value: "Edit" },
        delete: { type: "StageType", value: "Delete" },
        show: { type: "StageType", value: "Show" },
    },
    unit: {
        edit: { type: "Unit", value: "Edit" },
        delete: { type: "Unit", value: "Delete" },
        show: { type: "Unit", value: "Show" },
    },
    version: {
        edit: { type: "Version", value: "Edit" },
        delete: { type: "Version", value: "Delete" },
        show: { type: "Version", value: "Show" },
    },
    user: {
        edit: { type: "User", value: "Edit" },
        delete: { type: "User", value: "Delete" },
        show: { type: "User", value: "Show" },
    },



}